import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  Navbar as BsNavbar,
  Container,
  Nav,
  Offcanvas,
} from 'react-bootstrap'

const LINKS = [
  { to: '/',                 label: 'Home' },
  { to: '/quem-somos',       label: 'Quem Somos' },
  { to: '/nossos-produtos',  label: 'Nossos Produtos' },
  { to: '/pontos-de-venda',  label: 'Pontos de Venda' },
  { to: '/seja-revendedor',  label: 'Seja um Revendedor' },
]

export default function Navbar() {
  const { pathname } = useLocation()
  const [scrolled, setScrolled] = useState(false)
  const [show, setShow] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <BsNavbar
      expand="lg"
      fixed="top"
      className="cf-navbar"
      style={{ transition: 'box-shadow 0.3s', boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.5)' : 'none' }}
    >
      <Container>
        <BsNavbar.Brand as={Link} to="/">
          <img
            src="/images/logo_cleanfoods.png"
            alt="Clean Foods Brasil"
            style={{ height: 46 }}
          />
        </BsNavbar.Brand>

        {/* Desktop nav */}
        <BsNavbar.Collapse id="main-nav" className="d-none d-lg-flex">
          <Nav className="ms-auto align-items-center gap-1">
            {LINKS.map((link) => (
              <Nav.Link
                key={link.to}
                as={Link}
                to={link.to}
                className={pathname === link.to ? 'nav-link active' : 'nav-link'}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
        </BsNavbar.Collapse>

        {/* Mobile toggler */}
        <BsNavbar.Toggle
          aria-controls="mobile-offcanvas"
          className="d-lg-none border-0"
          onClick={() => setShow(true)}
          style={{ borderColor: 'var(--cf-yellow)' }}
        >
          <span className="navbar-toggler-icon" />
        </BsNavbar.Toggle>
      </Container>

      {/* Mobile Offcanvas */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="end"
        id="mobile-offcanvas"
        style={{ backgroundColor: 'var(--cf-dark)', maxWidth: 280 }}
      >
        <Offcanvas.Header closeButton closeVariant="white" className="border-bottom" style={{ borderColor: 'var(--cf-border)' }}>
          <Offcanvas.Title>
            <img src="/images/logo_cleanfoods.png" alt="Clean Foods Brasil" style={{ height: 36 }} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Nav className="flex-column pt-2">
            {LINKS.map((link) => (
              <Nav.Link
                key={link.to}
                as={Link}
                to={link.to}
                onClick={() => setShow(false)}
                className={`px-4 py-3 border-bottom ${pathname === link.to ? 'text-cf-yellow' : ''}`}
                style={{ borderColor: 'var(--cf-border)', color: pathname === link.to ? 'var(--cf-yellow)' : 'var(--cf-text)', fontWeight: 600, textTransform: 'uppercase', fontSize: '0.88rem', letterSpacing: '0.5px' }}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </BsNavbar>
  )
}
